<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button,
        Heading,
        InboxButton,
        Link,
        List,
        Paragraph,
        SESSION_USER,
    } from '@smatch/cassiopeia-web-components';

    // STYLING
    import 'tailwindcss/tailwind.css';

</script>

<Heading size = 'md'>Confirm Your Email</Heading>
<Paragraph>
    Please check your <strong>{ $SESSION_USER?.email }</strong>
    inbox for an email  to confirm your account registration.
</Paragraph>

<InboxButton email = { $SESSION_USER?.email } />

<div class = 's8-list'>

    <List mode = 'simple'>
        <li><Link url = '#onboarding/confirmation-resend'>Resend Confirmation Mail</Link></li>
        <li><Link url = '#onboarding/confirmation-update'>Change Email Address</Link></li>
    </List>

</div>

<div class = 's8-footer'>

    <Button
        type = 'button'
        label = 'Cancel'
        color = 'neutral'
        css = 'w-full'
        url = '#onboarding'
    />

</div>

<style lang='postcss'>

    div.s8-list {
        margin-top: 40px;
    }

    div.s8-footer {
        display: flex;
        column-gap: 10px;
        flex-grow: 1;
        align-items: flex-end;
    }

</style>